import { useCallback, useEffect, useRef } from 'react';

import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const commandBarRequestState = atom({
  key: 'commandBarRequest',
  default: { term: '', scope: null, drill: null, nonce: 0 }
});

export const commandSheetState = atom({ key: 'commandSheet', default: null });

export const commandBarOpenState = atom({ key: 'commandBarOpen', default: false });

export const commandImpersonateState = atom({ key: 'commandImpersonate', default: null });

export const commandTourState = atom({ key: 'commandTour', default: 0 });

export const useOpenCommandBar = () => {
  const setOpen = useSetRecoilState(commandBarOpenState);
  return useCallback(() => setOpen(true), [setOpen]);
};

export const useRequestCommandBar = () => {
  const setRequest = useSetRecoilState(commandBarRequestState);
  return useCallback(
    (request) =>
      setRequest((prev) => ({
        term: request?.term || '',
        scope: request?.scope || null,
        drill: request?.drill || null,
        nonce: prev.nonce + 1
      })),
    [setRequest]
  );
};

export const useRequestSmartSearchTour = () => {
  const setNonce = useSetRecoilState(commandTourState);
  return useCallback(() => setNonce((nonce) => nonce + 1), [setNonce]);
};

export const useSmartSearchTourRequest = (onRequest) => {
  const nonce = useRecoilValue(commandTourState);
  const handled = useRef(nonce);

  useEffect(() => {
    if (nonce === handled.current) return;
    handled.current = nonce;
    onRequest();
  }, [nonce, onRequest]);
};

export const useCommandBarRequest = (onRequest) => {
  const request = useRecoilValue(commandBarRequestState);
  const handledNonce = useRef(request.nonce);

  useEffect(() => {
    if (request.nonce === handledNonce.current) return;
    handledNonce.current = request.nonce;
    onRequest(request);
  }, [request, onRequest]);
};
